import { apiDelete } from "../ApiMethod";

export const deleteCampusById = async (id) => {
  const response = await apiDelete("_campuses", id);
  return { ...response };
};
